import {useTypedSelector} from "../hooks/useTypedSelector";
import Login from "../pages/Login";
import Researches from "../pages/Researches";
import Deck from "../pages/Deck";
import Offers from "../pages/Offers";
import GamePage from "../pages/GamePage";
import Arena from "../pages/Arena";
import GemShop from "../pages/GemShop";
import Workshop from "../pages/Workshop";
import MainMenu from "../componetns/menu/MainMenu";
import Home from "../pages/Home";
import BossWindow from "../pages/BossWindow";
import Story from "../pages/Story";
import {isMobile, isTablet} from "react-device-detect";
import Settings from "../pages/Settings";
import {IVersionError} from "../models/IVersionError";
import {config} from "../config";
import VersionErrorPage from "../pages/global_error/VersionErrorPage";
import InfoBanner from "../pages/InfoBanner";

const AppRouter = () => {
    const {isAuth, route, globalError} = useTypedSelector(state => state.auth);

    const components = {
        'home': Home,
        'gallery': Researches,
        'deck': Deck,
        'offers': Offers,
        'gem_shop': GemShop,
        'workshop': Workshop,
        'game': GamePage,
        'arena': Arena,
        'boss': BossWindow,
        'story': Story,
        'settings': Settings,
        'info_banner': InfoBanner,
    };

    const ComponentToRender = components[route];

    const isVersionError = (x: unknown): x is IVersionError => {
        return (
            typeof x === "object" &&
            x !== null &&
            "error" in x &&
            "current_version" in x &&
            "links" in x
        );
    };

    if (globalError !== null && isVersionError(globalError)) {

        return <VersionErrorPage error={globalError} clientVersion={config.VERSION}/>
    }

    if (!isAuth) {
        return <div className="RouteContainer"><Login/></div>;
    }

    const height = window.innerHeight;
    let zoom = 100;
    if (isMobile) {
        zoom = Math.round((6 / 35) * height - 3.71);
    }

    if (isTablet) {
        zoom = 87;
    }


    let stringZoom = zoom.toString();
    stringZoom += '%';

    if (route === 'game') {
        return (
            <div className="RouteContainer" style={{zoom: stringZoom}}>
                <GamePage/>
            </div>
        );
    }


    return (
        <div className="RouteContainer">
            <MainMenu>
                <ComponentToRender/>
            </MainMenu>
        </div>
    );
};

export default AppRouter;
